function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicrosoftTeamsArrow = function SvgMicrosoftTeamsArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 111.43 100.75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uMRFvP.tif"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.43,60.6l-25.09,0C88,46.87,85.2,34.16,77.24,22.75A51.81,51.81,0,0,0,51.05,3c-20.7-7.12-40.2-.29-51,9.13,1.26-.81,2.9-2,4.65-3A39,39,0,0,1,58.71,60.29a.66.66,0,0,1-.71.42l-26.23,0c-.14,0-.28,0-.55,0L71.4,100.75Z",
    style: {
      fill: "#7b82ea"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrosoftTeamsArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microsoft-teams-arrow.2625d9ac.svg";
export { ForwardRef as ReactComponent };